export default __webpack_public_path__ + "static/media/locked-icon.6b2d4697.svg";